import { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { getCampgroundImages } from "../../api-clients/iwannacamp-api";
import { getImageUrl } from "../../utils/images";
import { CampgroundImageLayout } from "./CampgroundImageLayout";

type CampgroundImagesProps = {
  defaultImage: string;
  campgroundId: string;
};

export const CampgroundImages = ({
  defaultImage,
  campgroundId,
}: CampgroundImagesProps) => {
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState<string[]>([defaultImage]);

  // Lightbox state
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const openImage = (index: number) => {
    setIndex(index);
    setOpen(true);
  };

  // Load images for campground
  useEffect(() => {
    getCampgroundImages({
      path: { campground_sqid: campgroundId },
    })
      .then(({ data }) => {
        if (data && data.length > 0) {
          setImages(data);
        }
      })
      .finally(() => setLoading(false));
  }, [campgroundId]);

  if (images.length === 0) {
    return null;
  }

  return (
    <>
      <Lightbox
        open={open}
        index={index}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        close={() => setOpen(false)}
        slides={images.map((image) => ({ src: getImageUrl(image, "large") }))}
        plugins={[Thumbnails, Counter, Zoom]}
      />
      <CampgroundImageLayout
        images={images.map((imageId) => getImageUrl(imageId, "large"))}
        openImage={openImage}
        loading={loading}
      />
    </>
  );
};
